import { ButtonBase } from ".";
import { ACTION_STATUS } from "..";

export class SaveButtonModel extends ButtonBase {
    label: string = 'Save';
    action: string = ACTION_STATUS.save;
    matIconName: string = 'save';
    colorClass: string = 'color-success-500';
}